/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line
// import { from, Observable } from 'rxjs'
import { Drawer, Button, Spin, message } from 'antd'
import Markdown from 'react-markdown'

import BusinessStatus from '../../business/status'
import StatusTag from '../../components/StatusTag'

import { userAction } from '../../action/user'
import { ViewerStyles } from './styles'
import { User } from '../../business/define'

import { listLoader } from '../../store/list/ListLoader'

import * as ContextUtils from '../../utils/context'

import UserEditDrawer from './UserEditDrawer'

export default (props: any) => {
  const [user, onUserChange] = useState<User>(null)
  const [visible, onVisibleChange] = useState(false)
  const [loading, onLoadChange] = useState(false)

  const loadUserData = () => {
    onLoadChange(true)
    userAction
      .fetchUserInfo(props['uid'])
      .then(responseData => {
        onUserChange(responseData.user)
        onVisibleChange(true)
        onLoadChange(false)
      })
      .catch((err) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  const onClickButton = () => {
    loadUserData()
  }

  const onChangeUserStatus = (uid: any, action: string) => {
    userAction.setUserStatus(uid, action)
      .then(responseData => {
        message.info('设置用户状态成功')
        loadUserData()
        listLoader.reloadListPage()
      })
      .catch((err) => {
        message.warning(err.message)
      })
  }

  return (
    <div css={ViewerStyles["data-drawer"]}>
      <Button type="link" onClick={onClickButton}>
        {props['uid']}
      </Button>
      {
        user && <Drawer
          width="320"
          title={`用户详情[${props['uid']}]`}
          placement="right"
          onClose={() => {
            onVisibleChange(false)
          }}
          visible={visible}
        >
          <div css={ViewerStyles["drawer-container"]}>
            <Spin spinning={loading}>
              <div css={ViewerStyles["drawer-body"]}>
                <p><UserEditDrawer record={user} user={user} text="编辑" onLoadChange={() => {
                  loadUserData()
                  listLoader.reloadListPage()
                }} /></p>
                <p>用户邮箱：{user['email']}</p>
                <p>状态：<StatusTag item={user} status={user.status} config={BusinessStatus.user} /></p>
                <Markdown source={ContextUtils.buildJsonMarked(user)} />
              </div>
              <div css={ViewerStyles["drawer-footer"]}>
                <Button type="primary" onClick={() => { onChangeUserStatus(user.id, 'active') }}>激活</Button>
                <Button type="danger" onClick={() => { onChangeUserStatus(user.id, 'disabled') }}>拉黑</Button>
              </div>
            </Spin>
          </div>
        </Drawer>
      }
    </div>
  )
}